import SendPlaneLineIcon from 'remixicon-react/SendPlaneLineIcon';
import LinkedinBoxLineIcon from 'remixicon-react/LinkedinBoxLineIcon';
import FileTextLineIcon from 'remixicon-react/FileTextLineIcon';
import Resume from '../../../assets/Kyle_Moreau_Resume.pdf';
import SectionHeading from '../../SectionHeading';

const stats = [
  { value: '300+', label: 'Live sites shipped' },
  { value: '45%', label: 'Faster page loads' },
  { value: '5,350+', label: 'Production issues resolved' },
];

const About = () => {
  return (
    <section id='about' className='px-5 py-20 md:px-10 lg:px-20 bg-white'>
      <div className='max-w-[900px] mx-auto'>
        <SectionHeading number='01 — About' title='About me' static />

        <div className='text-lg leading-8 text-ink/75 text-center max-w-[680px] mx-auto'>
          <p className='mb-5'>
            I'm a self-taught software engineer based in Los Angeles. I started
            my career as a junior front-end developer at Fox Dealer and worked
            my way up to a full-stack engineering role, continuing on with
            CatalystIQ after they acquired the company.
          </p>

          <p className='mb-5'>
            Today, I primarily focus on frontend performance and platform
            architecture—improving Core Web Vitals, optimizing render paths, and
            building scalable, config-driven systems that power hundreds of
            production websites.
          </p>

          <p className='mb-10'>
            I enjoy working across the entire development process, from early
            architecture decisions through deployment. One of the most rewarding
            parts of the job has been mentoring other engineers and helping them
            grow along the way.
          </p>

          <div className='flex flex-col items-center gap-4'>
            <a
              className='inline-flex items-center gap-2 bg-ink text-paper py-3 px-6 rounded-full font-medium transition-all duration-300 hover:bg-accent hover:-translate-y-0.5'
              href='#contact'
            >
              <SendPlaneLineIcon size={18} /> Contact Me
            </a>

            <div className='flex gap-3 items-center'>
              <a
                href='https://www.linkedin.com/in/kyle-moreau/'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='LinkedIn'
                className='h-10 w-10 flex items-center justify-center rounded-full border border-ink/15 text-ink/60 transition-all duration-300 hover:text-accent hover:border-accent hover:-translate-y-0.5'
              >
                <LinkedinBoxLineIcon size={20} />
              </a>
              <a
                href={Resume}
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Résumé'
                className='h-10 w-10 flex items-center justify-center rounded-full border border-ink/15 text-ink/60 transition-all duration-300 hover:text-accent hover:border-accent hover:-translate-y-0.5'
              >
                <FileTextLineIcon size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className='flex flex-wrap justify-center gap-x-14 gap-y-8 md:gap-x-20 mt-20 pt-14 border-t border-ink/10'>
          {stats.map((stat) => (
            <div
              key={stat.label}
              className='flex flex-col items-center text-center w-24 md:w-28'
            >
              <span className='font-serif text-4xl md:text-5xl font-semibold text-ink'>
                {stat.value}
              </span>
              <span className='mt-2 text-sm text-ink/50'>{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
